/** Shopify CDN: Minification failed

Line 25:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 46:16 Transforming let to the configured target environment ("es5") is not supported yet
Line 47:16 Transforming let to the configured target environment ("es5") is not supported yet
Line 48:16 Transforming let to the configured target environment ("es5") is not supported yet
Line 57:16 Transforming let to the configured target environment ("es5") is not supported yet
Line 58:16 Transforming let to the configured target environment ("es5") is not supported yet
Line 90:12 Transforming let to the configured target environment ("es5") is not supported yet
Line 91:12 Transforming let to the configured target environment ("es5") is not supported yet
Line 95:12 Transforming let to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/

var tsw = {
  fetchProductBlog: function () {
    var matchedTag = [];
    var random = [];
    const MAX_BLOG_ITEMS = 4;
    const other_tags = ["brand"];

    if ($(".tsw-product-blogs").length) {
      var productTags = $(".tsw-product-blogs")
        .data("product-tags")
        .toLowerCase();
      var productTagsArray = productTags.split(",").map(function (item) {
        return item.trim();
      });

      var all_blogs = all_product_blogs;
      var product_blogs = [];
      var other_blogs = [];

      var totalArticles = 0;

      // Categorize the blogs
      all_blogs.map(function (blog) {
        console.log("Working on blog : " + blog.id);

        let blogItem = blog;
        let blogTags = blog.tags.toLowerCase();
        let blogTagsArray = blogTags.split(",").map(function (item) {
          return item.trim();
        });

        // console.log('product tags array: ', productTagsArray);
        // console.log('blog tags array: ', blogTagsArray);

        // Check if blogTagsArray matches any value with productTagsArray
        let tagMatches = _.intersection(blogTagsArray, productTagsArray);
        let otherTagMatches = _.intersection(other_tags, blogTagsArray);
        if (tagMatches.length) {
          console.log(
            "product and blog tag array matched",
            blogTagsArray,
            productTagsArray
          );
          product_blogs.push(blogItem);
        } else if (otherTagMatches.length) {
          console.log("product and blog tag array did not match.");
          other_blogs.push(blogItem);
        } else {
          // Do nothing
        }

        console.log(product_blogs, other_blogs);

        // Start adding the blogs
        /*
                while ( product_blogs.length > 0 ) {
                    let randomInt = getRandomInt( 0, product_blogs.length - 1 );
                    let blog = product_blogs[ randomInt ];
                    tsw.appendBlog( blog );
                    product_blogs = _.reject( product_blogs, { id: blog.id } );
                }
                */
      });

      // Clear out the HTML
      $(".tsw-product-blogs  .blog-grid--4").html("");

      // Now shuffle the blogs
      let shuffledProductBlogs = _.shuffle(product_blogs);
      let shuffledOtherBlogs = _.shuffle(other_blogs);

      console.log("shuffled other blogs:: ", shuffledOtherBlogs);

      let finalBlogs = _.concat(shuffledProductBlogs, shuffledOtherBlogs);

      // Add PRODUCT max 2 blogs
      let productBlogsAdded = 0;
      shuffledProductBlogs.map(function (blog) {
        if (totalArticles < MAX_BLOG_ITEMS && productBlogsAdded < 2) {
          let blogAdded = tsw.appendBlog(blog);

          totalArticles++;
          productBlogsAdded++;
        }
      });

      // Add OTHER max 2 blogs
      let otherBlogsAdded = 0;
      shuffledOtherBlogs.map(function (blog) {
        if (totalArticles < MAX_BLOG_ITEMS) {
          let blogAdded = tsw.appendBlog(blog);

          totalArticles++;
          otherBlogsAdded++;
        }
      });

      // If no blogs were added then hide the blog section
      if (totalArticles < 1) {
        $(".product-blog-row").fadeOut(100);
      }
    }
  },

  appendBlog: function (blog) {
    console.log("Appending blog: ", blog);

    if (blog?.id) {
      var blogTags = blog.tags;
      var publishDate = dayjs(blog.published_at).format("MMM DD, YYYY");
      var blogImage = $(
        '.product-blog-article[data-article-id="' +
          blog.id +
          '"] .blog-article-thumbnail'
      ).html();
      var blogTagsArray = blogTags.split(",").map(function (item) {
        return item.trim();
      });

      var tagsHtml = "";
      blogTagsArray.map(function (blogtag) {
        let tag = slugify(blogtag.trim());
        tagsHtml += `<a target="_blank" href="${blog.blog_tag_url}${tag}"><span>${blogtag}</span></a>`;
      });

      var blogTemplate = `
            <article class="product-blog-article" data-tags="${blogTags}" id="product-blog--${blog.id}">
                    <div class="blog-article-thumbnail">
                        <a href="${blog.url}" title="${blog.escaped_title}">
                             ${blogImage}    
                        </a>
                    </div>
                    <div class="blog-post-details">
    
                        <aside class="post-meta">
                            ${publishDate}
                        </aside>
    
                        <h5><a href="${blog.url}" title="${blog.escaped_title}">${blog.title}</a></h5>
                        
                        <div class="post-excerpt">
                            <p>${blog.excerpt}</p>
                        </div>
             
                        <a href="${blog.url}" title="${blog.escaped_title}" class="text-button read-more">${blog.read_more_text}</a>
                    </div>
                    <div class="tags-links">
                        ${tagsHtml}
                    </div>
                </article>
            `;

      $(".tsw-product-blogs  .blog-grid--4").append(blogTemplate);
      console.log("Appended blog with id : ", blog.id, " name: ", blog.title);
    } else {
      return false;
    }

    return true;
  },
};
if (typeof Shopify.formatMoney == "undefined") {
  /**
   * Format currency value according to the store's currency format settings
   * @param {Number} amount - The numeric value to format
   * @param {String} currencyCode - The currency code (e.g., 'USD', 'EUR')
   * @returns {String} The formatted currency value
   */
  Shopify.formatMoney = function formatMoney(amount, currencyCode) {
    var currencyFormat = theme.moneyFormat;
    var formattedAmount = "";
    var amountString = amount.toString();

    // Replace placeholders in currency format with actual values
    console.log("Amount: ", amount);
    // Replace placeholders in currency format with actual values
    formattedAmount = currencyFormat
      .replace("{{amount}}", amountString)
      .replace("{{amount_no_decimals}}", amountString)
      .replace(
        "{{amount_with_comma_separator}}",
        amountString.replace(/\./g, ",")
      )
      .replace(
        "{{amount_no_decimals_with_comma_separator}}",
        amountString.replace(/\./g, ",")
      );

    // Replace currency placeholder with currency symbol or code
    formattedAmount = formattedAmount.replace("{{currency}}", currencyCode);

    return formattedAmount;
  };
}

if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON("/cart.js", function (cart, textStatus, xhr) {
        if (typeof callback === "function") {
          callback(cart, textStatus, xhr);
          console.log("done1");
        } else {
          console.log("done2");
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if (typeof callback === "function") {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === "function") {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}
/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */
// var cart = theme.settings.cart_drawer;

// On cart update, refetch the free gifts wrapper
function ajaxCart(form, button) {
  var isButtonFreeGift = $(button).parents(".tsw-free-cart-items").length;
  var isButtonRecommendedUnit = $(button).hasClass("RecommendedUnit-AddToCart");
  var data = form.serialize();
  var btnAddedText = isButtonFreeGift ? "ADDED" : "Added to cart!";
  var productForm = document.querySelector("product-form");

  // Disable the button before anything
  if (isButtonFreeGift) {
    $(".free-item-container .ProductForm__AddToCart").attr("disabled", true);
  }
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (line_item) {
      console.log("TEST CART ", line_item);
      if (productForm) {
        productForm.renderContents(line_item);
      }
      Shopify.getCart(function (cart) {
        //custom_theme.sidecart();

        // Cart data
        console.log("Triggering cart update");
        console.log("getCart: ", cart);

        dispatchCustomEvent("cart:item-added", {
          product: cart.hasOwnProperty("items") ? cart.items[0] : cart,
        });

        setTimeout(function () {
          if (!isButtonFreeGift && !isButtonRecommendedUnit) {
            jQuery(".header__desktop__button ")
              .find("a.navlink--cart")[0]
              .click();
            $(button).removeClass("added-to-cart").attr("disabled", false);
            button.text("Add to cart");
          } else {
            console.log(
              "is offer add to cart - init sidebar update differently"
            );
            document.dispatchEvent(
              new CustomEvent("change", {
                bubbles: true,
              })
            );

            if ($(".drawer__body").length) {
              var drawerScroller = $(".drawer__body")[0];
              drawerScroller.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }, 1500);

        button.text(btnAddedText);
        console.log(button);

        $(button).addClass("added-to-cart").attr("disabled", true);
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      var error = JSON.parse(XMLHttpRequest.responseText).description;
      var error_popup = $("<div id='quick-error'></div>");
      error_popup.html("");
      error_popup.append("<h6>" + error + "</h6>");
      alert(error);
      button.text(button.attr("data-text"));
      console.log(XMLHttpRequest.responseText);

      if (XMLHttpRequest.status) {
        console.log("request failed, removing all disabled buttons");
        $(".free-item-container .ProductForm__AddToCart").attr(
          "disabled",
          false
        );
      }
    },
  };
  jQuery.ajax(params);
}
//  This Code Commented out to Redirect on Cart Page For now
function ajacCartForm() {
  //ajax cart
  $(document).on("submit", ".collection-form", function (e) {
    e.preventDefault();
    console.log("clicked on Submit");
    var $form = $(this);
    var button = $(".single-add-to-cart-button", $form);
    button.text(button.attr("data-process"));
    // cart.init()

    /*
         document.dispatchEvent(
          new CustomEvent("cart:item-added", {
            bubbles: true,
          })
        );*/
    ajaxCart($form, button);
  });
}

$(document).ready(function () {
  tsw_gwp.fetchCartItems();
  if ($(".tsw-product-blogs").length) {
    tsw.fetchProductBlog();
  }
});

// utilities
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function slugify(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/*
 * Start Free offer items in cart
 */
var tsw_gwp = {
  fetchCartItems: function () {
    var timestamp = Date.now();
    fetch("/cart?section_id=api-free-offer-cart&timestamp=" + timestamp)
      .then(function (response) {
        return response.text();
      })
      .then(function (response) {
        console.log("Free cart items response: ", response.slice(0, 45));

        // append the html
        $(".free-gift-slider-cart").html(response);
        // $('#free_offer_items').html( response );

        $("#cartfreeoffer").html(response);

        // After appending it initialize swiper
        var swiper = new Swiper(".cartFreeItemsSwiper", {
          slidesPerView: "auto",
          spaceBetween: 5,

          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },

          breakpoints: {
            320: {
              slidesPerView: "auto",
              spaceBetween: 10,
              centeredSlides: false,
            },
            640: {
              slidesPerView: "auto",
              spaceBetween: 5,
              centeredSlides: true,
              centeredSlides: false,
            },

            1024: {
              slidesPerView: 3,
              spaceBetween: 15,
              centeredSlides: false,
            },
          },
        });

        if (
          $(".free-item-preview").length &&
          !$(".tsw-free-cart-items-disabled").length
        ) {
          $(".cart-free-items-heading").removeClass("hidden");
        } else {
          $(".cart-free-items-heading").addClass("hidden");
        }

        // Validate Free gifts in cart
        tsw_gwp.validateFreeGift();

        // Progress meter
        if ($("#offerdiff").length && $(".free-items-progress-text").length) {
          console.log("Show progress meter only if #offerdiff exists");

          let offerPrice = parseInt($("#offerdiff").data("offer-price"));
          let cartPrice = parseInt($("#offerdiff").data("tag-offer-price"));
          console.log("Price  :" + cartPrice / offerPrice);
          console.log("CartPrice :" + cartPrice);

          let percentage = parseInt((cartPrice / offerPrice) * 100);
          let diff = offerPrice - cartPrice;
          console.log("diff :" + diff);

          var offerPriceText = $(".free-items-progress-text").data("text");
          console.log(Shopify.money_format);
          var priceDiff = diff;

          if (Shopify.money_format) {
            priceDiff = Shopify.money_format.replace(
              "{{amount_no_decimals}}",
              diff
            );
          }
          $(".free-items-progress-text").html(
            offerPriceText.replace("#{value}", priceDiff)
          );

          var prelimit_text = $(".free-gift-heading-nothreshold span").text();
          $(".free-gift-heading-nothreshold span").html(
            prelimit_text.replace("||amount||", offerPrice)
          );

          // progress color
          let decimalPercentage = percentage / 100;
          decimalPercentage = decimalPercentage < 0.2 ? 0.2 : decimalPercentage;

          if (percentage <= 100) {
            $(".cart-free-items-progress").addClass("progress-show");
          }
          // purple rgba(135, 40, 245, 1)

          let progressColor = `rgba(135, 40, 245,${decimalPercentage})`;
          progressColor = `#DDC5F2`; /* purple */
          $(".cart-free-items-progress .progress-meter").css({
            "--progress-line-color": progressColor,
          });
          $(".cart-free-items-progress .progress-meter .progress-line").css({
            width: percentage + "%",
          });

          if (percentage >= 100) {
            $(".cart-free-items-progress").removeClass("progress-show");
          } else {
            $(".cart-free-items-progress").addClass("progress-show");
          }
        }
      })
      .catch(function (err) {
        console.log("Failed to fetch page: ", err);
      });
    // var timestamp=Date.now();
    fetch("/cart?section_id=api-free-offer-item&timestamp=" + timestamp)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        document.querySelector("#free_offer_items").innerHTML = html;
        var swiper = new Swiper(".cart-free-wrap-grid .cartFreeItemsSwiper", {
          slidesPerView: "auto",
          spaceBetween: 5,

          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },

          breakpoints: {
            320: {
              slidesPerView: "auto",
              spaceBetween: 10,
              centeredSlides: false,
            },
            640: {
              slidesPerView: "auto",
              spaceBetween: 5,
              centeredSlides: true,
              centeredSlides: false,
            },

            1024: {
              slidesPerView: 3,
              spaceBetween: 15,
              centeredSlides: false,
            },
          },
        });
      })
      .catch(function (err) {
        console.log("Failed to fetch page: ", err);
      });
  },

  validateFreeGift: function () {
    Shopify.getCart(function (cart) {
      let offerPrice = parseInt($("#offerdiff").data("offer-price"));
      let cartPrice = parseInt($("#offerdiff").data("tag-offer-price"));
      let freeGiftTag = $("#offerdiff").data("free-gift-tag");
      var isEligible = false;
      var doesHaveFreeGift = false;

      console.log(offerPrice);
      console.log(cartPrice);
      if (offerPrice /* && cartPrice */) {
        if (cartPrice >= offerPrice) {
          console.log("You are eligible for a free gift!");
          isEligible = true;
        } else {
          console.log("You are NOT eligible for a free gift!");
          isEligible = false;
        }

        if (!isEligible) {
          console.log("NOT ELIGIBLE - CHECK CART AND REMOVE ITEMS : ", cart);
          for (var i in cart.items) {
            let item = cart.items[i];
            console.log(item.product_type.trim() == freeGiftTag.trim());

            if (item.product_type.trim() == freeGiftTag.trim()) {
              doesHaveFreeGift = true;
              console.log(doesHaveFreeGift);

              // remove
              console.log("Remove the free gift " + parseInt(i));
              tsw_gwp.removeProduct(parseInt(i), 0);

              // this.removeProductEvent();
            }
          }
        }
      }

      // If is eligible, however they have multiple quantities of Free Gifts in Cart.
      // change - 2/2/2023 by Depy
      if (isEligible) {
        let foundFreeGift = false;
        let numberOfFreeGifts = 0;
        let changeValues = { updates: {} };
        let shouldUpdate = false;

        for (var i in cart.items) {
          let item = cart.items[i];

          if (item.product_type.trim() == freeGiftTag.trim()) {
            /*
                        if ( foundFreeGift ) {
                            console.log('ALREADY FOUND A FREE GIFT, YOU CAN NOT HAVE MORE THAN 1 FREE GIFT IN YOUR CART');
                            tsw.removeProduct( parseInt(i), 0 );
                        } else {
                            // and if this is the first free gift then update its quantity.
                        }
                        */

            let productKey = item.key;
            let quantity = 1;

            if (foundFreeGift) {
              quantity = 0;
              shouldUpdate = true;
            } else {
              if (item.quantity > 1) {
                shouldUpdate = true;
              }
            }

            changeValues.updates[productKey] = quantity;

            foundFreeGift = true;
            numberOfFreeGifts++;
          }

          console.log("Number of free gifts in cart: " + numberOfFreeGifts);
        }

        // whether or not we should update the cart
        if (shouldUpdate) {
          console.log(
            `Number of Free gifts ${numberOfFreeGifts} | `,
            changeValues
          );

          var params = {
            type: "POST",
            url: `/cart/update.js`,
            data: true,
            dataType: "json",
            success: function (line_item) {
              tsw_gwp.updateCart();
            },
            error: function (XMLHttpRequest, textStatus) {
              console.log("Some error occured", XMLHttpRequest);
            },
          };

          jQuery.ajax(params);
        }
      }
    });
  },

  removeProduct: function (index, qty = 0) {
    const data = {
      line: index,
      quantity: qty,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };
    var params = {
      type: "POST",
      url: `${window.theme.routes.cart_change_url}`,
      data: data,
      dataType: "json",
      success: function (line_item) {
        console.log("remove API Called");
        updateCartHtml();
      },
      error: function (XMLHttpRequest, textStatus) {
        console.log("Some error occured", XMLHttpRequest);
      },
    };
    jQuery.ajax(params);
  },
  getSectionsToRender: function () {
    return [
      {
        id: "Cart",
        section: "main-cart",
        selector: ".thb-cart-form",
      },
      {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  },
  updateCart: function () {
    Shopify.getCart(function (cart) {
      //custom_theme.sidecart();
      document.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

      // Cart data
      console.log("Triggering cart update");
      document.dispatchEvent(
        new CustomEvent("line-item:change:end", {
          cart: cart,
          bubbles: true,
        })
      );
    });
  },

  calculateSaved: function () {
    console.log("Calculating saved amount..");
    $cartItems = $(".product-cart-item--container .product-cart-item");
    $cartItemTotalDiscount = $(".drawer .product-cart-item--container").data(
      "total-discount"
    );
    $totalFinalPrice = 0;
    $totalCompareWith = 0;
    $totalSaved = 0;

    $cartItems.each(function (e) {
      $cart_item_price = $(this).find(".product-cart-item-price");
      if ($cart_item_price.length) {
        let lineQty = $cart_item_price.data("line-item-qty");
        let lineComparePrice = $cart_item_price.data(
          "line-item-compare_at_price"
        );
        let lineFinalPrice = $cart_item_price.data("line-item-final_price");
        let itemDiscountedPrice = $cart_item_price.data(
          "discounted-item-price"
        );
        let lineOriginalLinePrice = $cart_item_price.data(
          "line-item-line_price"
        );

        console.log(lineQty);
        if (lineQty) {
          // Add to total compare with price
          if (lineComparePrice) {
            $totalCompareWith += lineComparePrice * lineQty;
          } else if (lineOriginalLinePrice) {
            console.log("Line original line price: ", lineOriginalLinePrice);
            $totalCompareWith += lineOriginalLinePrice /* * lineQty */; // don't need to multiply it, line item always give multiplied value
          } else {
            $totalCompareWith += lineFinalPrice * lineQty;
          }

          // Add to final price
          $totalFinalPrice += lineFinalPrice * lineQty;
        }
      }
    });

    console.log("total compare with price : ", $totalCompareWith);
    console.log("total final price : ", $totalFinalPrice);

    // Calculate the saved amount
    if ($totalCompareWith > $totalFinalPrice) {
      $totalSaved = $totalCompareWith - $totalFinalPrice;
    }

    // After the items also calculate the total cart discounts
    console.log("total cart discount : ", $cartItemTotalDiscount);
    if ($cartItemTotalDiscount) {
      // $totalSaved += $cartItemTotalDiscount;
    }

    // Insert into the UI
    if ($totalSaved) {
      console.log("Total Saved:: ", $totalSaved);
      let templateText = $(".saved-amount-message .saved-message-text").data(
        "text"
      );
      if (templateText) {
        let templateText = $(".saved-amount-message .saved-message-text").data(
          "text"
        );

        let moneyFormat = Shopify.formatMoney($totalSaved);
        let updatedText = templateText.replace("||amount||", moneyFormat);
        $(".saved-amount-message .saved-message-text").html(updatedText);
        $(".saved-amount-message").fadeIn();

        $(".saved-amount-message").addClass("glow");
        window.setTimeout(function () {
          $(".saved-amount-message").removeClass("glow");
        }, 700);

        // CONFETTI FUN!
        if ($totalSaved > lastSaved) {
          $("#confetti-canvas").fadeIn(100);
          // you should  only initialize a canvas once, so save this function
          // we'll save it to the canvas itself for the purpose of this demo
          // Confetti canvas
          confettiCanvas = document.getElementById("confetti-canvas");

          if (confettiCanvas) {
            confettiCanvas.confetti =
              confettiCanvas.confetti ||
              confetti.create(confettiCanvas, { resize: true });
            confettiCanvas.confetti({
              spread: 70,
              origin: { y: 1.2 },
            });
          }

          window.setTimeout(function () {
            $("#confetti-canvas").fadeOut(700);
          }, 2500);
        }

        lastSaved = $totalSaved;
      }
    } else {
      $(".saved-amount-message p").text("");
      $(".saved-amount-message").fadeOut();
    }

    return $totalSaved;
  },

  // Fetch recommended unit,
  fetchRecommendedUnits: function () {
    var timestamp = Date.now();
    fetch("/cart?section_id=api-recommended-unit&timestamp=" + timestamp)
      .then(function (response) {
        return response.text();
      })
      .then(function (response) {
        console.log("Recommended Unit Response: ", response.slice(0, 45));

        // append the html
        $(".tsw-cart-recommended-container").html(response);

        // Hide the unit if number of products is 0
        var numberOfProducts = $(
          ".tsw-cart-recommended-container .recommended-slides-wrap .cart-item-slide"
        ).length;
        if (numberOfProducts) {
          $(".tsw-cart-recommended-container").fadeIn(200);
        } else {
          $(".tsw-cart-recommended-container").fadeOut(200);
        }

        // After appending it initialize swiper
        var swiper = new Swiper(".cartRecommendedUnitSwiper", {
          slidesPerView: "auto",
          spaceBetween: 5,

          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },

          breakpoints: {
            320: {
              slidesPerView: "auto",
              spaceBetween: 10,
              centeredSlides: false,
            },
            640: {
              slidesPerView: "auto",
              spaceBetween: 5,
              centeredSlides: true,
              centeredSlides: false,
            },

            1024: {
              slidesPerView: 3,
              spaceBetween: 15,
              centeredSlides: false,
            },
          },
        });
      })
      .catch(function (err) {
        console.log("Failed to fetch page: ", err);
      });
  },
};
dispatchCustomEvent("change", function () {
  console.log("theme:cart:changed");
  if (tsw_gwp) {
    console.log("TSW theme:cart:changed");
    tsw_gwp.fetchCartItems();
    console.log("Using theme:cart:change to refetch TSW offer cart items");
  }
});
$(document).ready(function () {
  console.log("Free offer items start here..");

  tsw_gwp.fetchCartItems();

  $("#test-cart-products .rte").removeClass("rte");
  $("#test-cart-products .font--3").removeClass("font--3 standard__rte");

  $("body").on("click", ".close-item-preview", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $(".free-item-preview").removeClass("show-preview");
  });

  $("body").on(
    "click",
    ".product-img-zoom, .product-img-zoom-link",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var prd_img = $(".cart-item-img").attr("src");
      console.log("Prd_img : " + prd_img);
      $(".free-item-preview").addClass("show-preview");
      $(".free-item-preview .free-item-preview-img img").attr("src", prd_img);
    }
  );

  // Smooth scroll with offer heading in sidebar cart
  $("body").on("click", "[data-offer-target]", function (e) {
    e.preventDefault();
    $("[data-drawer-scrolls]").animate(
      {
        scrollTop: $("#shopify-section-api-free-offer-cart").offset().top - 20,
      },
      700
    );
  });
});

console.log("cartDrawer pre");

$(document).ready(function () {
  var cartDrawer = document.getElementById("Cart-Drawer");
  console.log(cartDrawer);
  let _this = this,
    button = document.getElementById("cart-drawer-toggle"),
    quantities = document.querySelectorAll(".quantity input");
  ATCbutton = document.getElementById("AddToCart");

  // tsw_gwp.updateCart();
  console.log(ATCbutton);
  // Add functionality to buttons
  document.addEventListener("cart:item-added", function (event) {
    // Your event handling code goes here
    console.log("Cart item added:", event);

    tsw_gwp.fetchCartItems();
    // tsw_gwp.fetchRecommendedUnits();
  });
  document.addEventListener("change", function (event) {
    // Your event handling code goes here
    console.log("change event :", event);

    tsw_gwp.fetchCartItems();
    // tsw_gwp.fetchRecommendedUnits();
  });

  button.addEventListener("click", (e) => {
    console.log("Event Fired");

    dispatchCustomEvent("cart-drawer:open");
    if (tsw_gwp) {
      tsw_gwp.fetchCartItems();
      // tsw_gwp.fetchRecommendedUnits();

      window.setTimeout(function () {
        tsw_gwp.calculateSaved();
        this.ajacCartForm();
      }, 1200);

      console.log("Using theme:drawer:open to refetch TSW offer cart items");
    }
  });

  // if ( cartDrawer ) {
  cartDrawer.addEventListener("cart-drawer:open", function () {
    console.log("cartDrawer");

    if (tsw_gwp) {
      tsw_gwp.fetchCartItems();
      // tsw_gwp.fetchRecommendedUnits();

      window.setTimeout(function () {
        tsw_gwp.calculateSaved();
      }, 1200);

      console.log("Using theme:drawer:open to refetch TSW offer cart items");
    }
  });
  // }
});

document.addEventListener("cart:item-added", function () {
  console.log("Event Listend");
  if (tsw_gwp) {
    tsw_gwp.fetchCartItems();
    // tsw_gwp.fetchRecommendedUnits();
    window.setTimeout(function () {
      tsw_gwp.calculateSaved();
    }, 800);
    console.log("INIT: Using theme:cart:init to refetch TSW offer cart items");
  }
});
document.addEventListener("line-item:change:start", function () {
  if (tsw_gwp) {
    tsw_gwp.fetchCartItems();
    // tsw_gwp.fetchRecommendedUnits();
    window.setTimeout(function () {
      tsw_gwp.calculateSaved();
    }, 800);
    console.log(
      "ITEM INIT: Using theme:cart:init to refetch TSW offer cart items"
    );
  }
});
document.addEventListener("line-item:change:end", function () {
  if (tsw_gwp) {
    tsw_gwp.fetchCartItems();
    // tsw_gwp.fetchRecommendedUnits();
    window.setTimeout(function () {
      tsw_gwp.calculateSaved();
    }, 1500);
    console.log(
      "RELOAD: Using theme:cart:reload to refetch TSW offer cart items"
    );
  }
});
document.addEventListener("change", function () {
  if (tsw_gwp) {
    tsw_gwp.fetchCartItems();
    window.setTimeout(function () {
      tsw_gwp.calculateSaved();
    }, 800);
    console.log(
      "NEW CHANGE RELOAD: Using theme:cart:reload to refetch TSW offer cart items"
    );
  }
});
function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector)?.innerHTML;
}

function getSectionsToRender() {
  let sections = [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  if (document.querySelector("#main-cart-footer .free-shipping")) {
    sections.push({
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer")?.dataset.id,
      selector: ".free-shipping",
    });
  }
  return sections;
}
function updateCartHtml() {
  const sections = getSectionsToRender().map((section) => section.section);

  const body = JSON.stringify({
    line: 0,
    quantity: 1,
    sections: sections,
    sections_url: window.location.pathname,
  });

  fetch(`${window.theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        ...{
          body
        }
      })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      //console.log(state)
      const parsedState = JSON.parse(state);
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      
      setTimeout(function () {
        getSectionsToRender().forEach((section) => {
          console.log(section);
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });
      }, 1500);
      dispatchCustomEvent('line-item:change:end', {
          quantity: 1,
          cart: state
      });
      if (jQuery(".cart-drawer-container.menu-opening").length < 1) {
        $("#cart-icon-bubble ").click();
      }
    });
}

// ajacCartForm();

//Aman's JS

document.addEventListener('DOMContentLoaded', function() {
  var paymentMethodInput = document.querySelector('input[name="checkout[basic]"]');
  var shippingMethodInput = document.querySelectorAll('input[name="checkout[shipping_methods][shipping_methods-9406b36b1c505a45bde00fca5a5ec5c2-fb412dccc276414f0041b834f676c462]"]');
  
  function validateShippingMethod() {
    var selectedPaymentMethod = document.querySelector('input[name="checkout[basic]"]:checked');
    var selectedShippingMethod = document.querySelector('input[name="checkou[shipping_methods][shipping_methods-9406b36b1c505a45bde00fca5a5ec5c2-fb412dccc276414f0041b834f676c462]"]:checked');
    
    if (selectedPaymentMethod && selectedShippingMethod) {
      var paymentMethodValue = selectedPaymentMethod.value;
      var shippingMethodValue = selectedShippingMethod.value;

      // Assuming COD payment method value is "cod"
      if (paymentMethodValue === 'cod' && shippingMethodValue === 'prepaid_shipping_rate_id') {
        alert('Please select the correct shipping method for COD orders.');
        return false;
      }
    }
    return true;
  }
  
  if (paymentMethodInput) {
    paymentMethodInput.addEventListener('change', validateShippingMethod);
  }
  
  shippingMethodInput.forEach(function(input) {
    input.addEventListener('change', validateShippingMethod);
  });
});


